export { default } from './CompletionBadge';
